<template>
	<el-dialog :title="!dataForm.subjectNo ? '新增标的物' : '修改标的物'" :close-on-click-modal="false" :visible.sync="visible"
		width="900px" :append-to-body="true">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px" :inline="true"
			class="border-form">
			<el-row class="set_border">
				<el-col :span="12" class="col-set_border">
					<el-form-item label="编号" prop="projectNo" class="item">
						<el-input v-model="dataForm.projectNo" placeholder="请输入" style="width:250px"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="名称" prop="subjectName" class="item">
						<el-input v-model="dataForm.subjectName" placeholder="请输入" style="width:250px"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="12" class="col-set_border">
					<el-form-item label="序号" prop="sort" class="item">
						<el-input v-model="dataForm.sort" placeholder="请输入" style="width:250px"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12" class="col-set_border">
					<el-form-item label="周报使用" prop="sort" class="item">
						<el-select v-model="dataForm.useWeek" placeholder="" style="width:250px" clearable>
							<el-option v-for="(item, index) in useList" :key="index" :label="item.displayName"
								:value="item.displayValue">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="12" class="col-set_border">
					<el-form-item label="月报使用" prop="sort" class="item">
						<el-select v-model="dataForm.useMonth" placeholder="" style="width:250px" clearable>
							<el-option v-for="(item, index) in useList" :key="index" :label="item.displayName"
								:value="item.displayValue">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12" class="col-set_border">
					<el-form-item label="日志使用" prop="sort" class="item">
						<el-select v-model="dataForm.useWorkLog" placeholder="" style="width:250px" clearable>
							<el-option v-for="(item, index) in useList" :key="index" :label="item.displayName"
								:value="item.displayValue">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<div class="formItemTitle" style="margin:18px 0px">
				参数信息
				<el-button v-preventReClick type="warning" size="small" icon="el-icon-plus" style="float: right;"
					@click="addParamList()">添加参数</el-button>
			</div>
			<!-- 参数表头行 -->
			<el-row style="text-align: center; margin-bottom: 8px;" class="param-header-row">
				<el-col :span="10" class="param-header-cell">参数名</el-col>
				<el-col :span="10" class="param-header-cell">参数值</el-col>
				<el-col :span="4"></el-col>
			</el-row>
			<!-- 参数输入行 -->
			<el-row style="text-align: center; margin-bottom: 8px;"
				v-for="(paramItem, paramIndex) in dataForm.paramInfoList" :key="paramIndex">
				<el-col :span="10">
					<el-form-item label="" prop="paramName" label-width="0" class="param-form-item">
						<el-input class="selItemInput" v-model="paramItem.paramName" placeholder="请输入"
							style="width:300px"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="10">
					<el-form-item label="" prop="paramValue" label-width="0" class="param-form-item">
						<el-input class="selItemInput" v-model="paramItem.paramValue" placeholder="请输入"
							style="width:300px"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="4">
					<el-button v-preventReClick type="danger" size="small"
						@click="delParamList(paramIndex)">删除</el-button>
				</el-col>
			</el-row>
		</el-form>
		<el-row class="formBtnGroup">
			<el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">确定</el-button>
			<el-button v-preventReClick class="rebtn" size="small" plain @click="visible = false">取消</el-button>
		</el-row>
	</el-dialog>
</template>

<script>

import $common from "@/utils/common.js"
export default {
	name: "subjectList-add-or-update",
	data() {
		return {
			visible: false,
			inline: false,
			subjectTypeList: [],
			operateType: '',
			dataForm: {
				subjectNo: '',
				remark: '',
				subjectName: '',
				sort: '',
				useWeek: '',
				useMonth: '',
				useWorkLog: '',
				projectNo: '',
				workNo: '',
				paramInfoList: [
					{
						paramName: "",
						paramValue: ""
					}
				]
			},
			useList: [
				{
					displayName: '是',
					displayValue: '1',
				},
				{
					displayName: '否',
					displayValue: '0',
				}
			],
			paramInfoList: [
				{
					paramName: "",
					paramValue: ""
				}
			],
			dataRule: {
				projectNo: [
					{ required: true, message: "编号不能为空", trigger: "blur" }
				],
				subjectName: [
					{ required: true, message: "名称不能为空", trigger: "blur" }
				],
				sort: [
					{ required: true, message: "排序不能为空", trigger: "blur" }
				]
			},
		}
	},
	computed: {
		updateSubjectList: {
			get() { return this.$store.state.common.navBarSubjectList },
			set(val) { this.$store.commit('common/updateSubjectList', val) }
		},
	},
	methods: {
		init(id, type) {
			this.dataForm = {
				subjectNo: '',
				remark: '',
				subjectName: '',
				projectNo: '',
				sort: '',
				workNo: '',
				useWeek: '',
				useMonth: '',
				useWorkLog: '',
				paramInfoList: [
					{
						paramName: "",
						paramValue: ""
					}
				]
			}
			this.operateType = type
			this.dataForm.subjectNo = id ? id : "";
			this.dataForm.workNo = $common.getItem("workNo");
			this.getSubjectType();
			if (id != null) {
				this.getDetail();
			}
			this.visible = true;
			this.$nextTick(() => {
				this.$refs["dataForm"].resetFields()
			})
		},
		getDetail() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/subjectinfo/info/" + this.dataForm.subjectNo,
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.projectNo = data.body.projectNo;
					this.dataForm.delFlg = data.body.delFlg;
					this.dataForm.subjectName = data.body.subjectName;
					this.dataForm.projectNo = data.body.projectNo;
					this.dataForm.subjectNo = data.body.subjectNo;
					this.dataForm.workNo = data.body.workNo;
					this.dataForm.paramInfoList = data.body.paramInfoList;
					this.dataForm.sort = data.body.sort;
					this.dataForm.useWeek = data.body.useWeek;
					this.dataForm.useMonth = data.body.useMonth;
					this.dataForm.useWorkLog = data.body.useWorkLog;
				}
			});
		},
		getSubjectType() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getSubjectType",
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectTypeList = data.body;
				}
			});
		},
		addParamList() {
			let _dataForm = this.dataForm;
			let _list = _dataForm.paramInfoList;
			_list.push({
				paramName: "",
				paramValue: ""
			})
			_dataForm.paramInfoList = _list;
			this.dataForm = _dataForm;
		},
		delParamList(index) {
			let _dataForm = this.dataForm;
			let _list = _dataForm.paramInfoList;
			_list.splice(index, 1);
			_dataForm.paramInfoList = _list;
			this.dataForm = _dataForm;
		},
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$store.commit('common/updateSubjectList', data.body)
					this.$store.commit('common/updateSelectSubjectNo', data.body[0].displayValue)
				}
			});
		},
		dataFormSubmit() {
			this.$refs["dataForm"].validate(valid => {
				if (valid) {
					let _url = "/business/subjectinfo/save";
					if (this.dataForm && this.dataForm.subjectNo != 0) {
						_url = "/business/subjectinfo/update";
					}
					this.$http({
						url: this.$store.state.httpUrl + _url,
						method: "post",
						data: this.$http.adornData(this.dataForm)
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.visible = false;
									console.log("dataFormSubmit operateType", this.operateType)
									if (this.operateType == '' || this.operateType == null) {
										this.$emit("refreshDataList");
										this.getSubjectDropDown()
									} else {
										sessionStorage.setItem('workNo', JSON.stringify(this.dataForm.workNo))
										// 一级权限菜单定位到第一个
										sessionStorage.setItem('menuIndex', 0)
										sessionStorage.setItem('subMenuIndex', 0)
										this.$cookie.set('showSidebarFlag', false)
										this.getSubjectDropDownList();
									}
								}
							});
						} else {
							this.$message.error(data.msg);
						}
					});
				}
			});
		},
		getSubjectDropDownList() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectList = data.body;
					this.$store.commit('common/updateSubjectList', this.subjectList)
					if (this.subjectList.length != undefined && this.subjectList.length > 0) {
						if ($common.getItem("subjectNo") == "" || $common.getItem("subjectNo") == undefined) {
							$common.setItem("subjectNo", this.subjectList[0].displayValue);
							this.$store.commit('common/updateSelectSubjectNo', this.subjectNo)
						}
					}
				}
				this.$router.push({ name: 'workbench' })
			});
		},
	}
}
</script>
<style scoped>
/* 全局字体大小（除dialog外） */
:root {
	font-size: 13px;
}

/* dialog 内部统一字体大小控制 */
.el-dialog {
	font-size: initial;
}

/* el-form-item 高度设置为33px */
::v-deep .el-form-item {
	display: flex !important;
	align-items: stretch !important;
	margin-bottom: 0px !important;
	height: 37px !important;
}

/* 所有输入框高度设置为32px */
::v-deep .el-input,
::v-deep .el-input__inner,
::v-deep .selItemInput {
	height: 32px !important;
	line-height: 32px !important;
}

/* 参数表头样式 - 与输入框垂直居中对齐 */
.param-header-row {
	display: flex;
	align-items: center;
	text-align: center;
	height: 32px;
	/* 与输入框高度一致 */
}

.param-header-cell {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	font-size: 13px;
}

/* 参数表单项样式调整 */
::v-deep .param-form-item {
	display: flex;
	justify-content: center;
}

.formItemTitle {
	margin: 12px 0px !important;
	/* 可选：缩小标题间距 */
}

/* 原有样式保留 */
.border-form .el-row.set_border {
	border-bottom: solid #dadada 1px;
	border-left: solid #dadada 1px;
	border-right: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 1px;
}

.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
}

.border-form .el-row.set_border .col-set_border {
	border-right: 1px solid #dadada;
}
</style>